import { render, staticRenderFns } from "./HistoricoReprocessamentoModal.vue?vue&type=template&id=c4c6590a&scoped=true&"
import script from "./HistoricoReprocessamentoModal.vue?vue&type=script&lang=js&"
export * from "./HistoricoReprocessamentoModal.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoReprocessamentoModal.vue?vue&type=style&index=0&id=c4c6590a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c6590a",
  null
  
)

export default component.exports